import React from "react";
import { withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Tooltip from "@material-ui/core/Tooltip";
import UploadDropzone from "../../../../../ui/FileIUpload/UploadDropzone";
import InfoField from "../../../../../ui/InfoDrawer/components/InfoField";
import IconButton from "@material-ui/core/IconButton";
import moment from "moment";
import Grid from "@material-ui/core/Grid";

import { ReactComponent as IconRemove } from "./../../../../../images/iconRemove24.svg";
import AttachmentCard from "../../../../../ui/AttachmentCard";

const useStyles = theme => ({
  content: {
    boxSizing: "border-box",
    maxWidth: 800,
    "& .MuiFormControl-root": {
      width: "100%",
      marginBottom: "10px"
    },
    "& > span": {
      fontSize: "14px",
      lineHeight: "18px"
    },
    "& .MuiAutocomplete-input": {
      flexGrow: 0.9
    },
    "& .MuiInput-root": {
      display: "flex",
      justifyContent: "space-between"
    }
  },
  column: {
    width: "368px",
    [theme.breakpoints.down(774)]: {
      width: "100%"
    }
  },
  columnRight: {
    display: "flex",
    justifyContent: "space-between",
    "& .MuiFormControl-root": {
      width: "80px"
    }
  },
  textAreaTop: {
    display: "flex",
    justifyContent: "space-between",
    [theme.breakpoints.down(1024)]: {
      flexDirection: "column"
    },
    marginTop: "6px",
    marginBottom: "35px"
  },
  status: {
    marginTop: "15px"
  },
  files: {
    display: "flex",
    justifyContent: "space-between"
  },
  leftColumn: {
    width: "368px",
    [theme.breakpoints.down(774)]: {
      width: "100%"
    },
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end"
  },

  infoElem: {
    justifyContent: "flex-start"
  },
  dropzoneWraper: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "flex-end"
  },
  dropZoneButtonArea: {
    width: 75,
    height: 35,
    zIndex: 1000,
    position: "absolute",
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "flex-end",
    "& svg": {
      marginRight: 8,
      marginBottom: 8,
      cursor: "pointer",
      backgroundColor: "#007fbd",
      borderRadius: "50%",
      "&:hover": {
        opacity: "0.8"
      },
      "& path": {
        fill: "#fff"
      }
    }
  },

  iconButton: {
    padding: 0,
    "&:hover": {
      backgroundColor: "transparent"
    }
  }
});

const BasicInfo = ({
  moduleInformation,
  skils,
  specialities,
  educationForm,
  trialForm,
  change,
  addModuleCardLogo,
  deleteModuleCardLogo,
  addModuleProgram,
  deleteModuleProgram,
  classes,
  disabled
}) => {
  /* const classes = useStyles(); */
  const { program } = moduleInformation.info;
  const tooltipSkils = skils.find(
    item => item.id === moduleInformation.data.skill
  );
  const tooltipSpecialities = specialities.find(
    item => item.id === moduleInformation.data.speciality
  );

  //const isMedium = useMediaQuery({ maxWidth: 1024 });
  /* 	const isLarge = useMediaQuery({ minWidth: 1024 });
	const isSmall = useMediaQuery({ maxWidth: 774 }); */

  /* localStorage.setItem("moduleInformation", JSON.stringify(moduleInformation));
  const modulInfo = JSON.parse(localStorage.getItem("moduleInformation"));

  console.log(modulInfo); */

  return (
    <div className={classes.content}>
      <span>Основная информация</span>
      <div className={classes.textAreaTop}>
        <Grid item md={5} xs={12} className={classes.leftColumn}>
          <TextField
            label="Наименование"
            required
            value={moduleInformation.data.name || ""}
            InputLabelProps={{
              shrink: true
            }}
            disabled={disabled}
            onChange={e => change("name", e.target.value)}
          />
          <Tooltip
            title={tooltipSkils ? tooltipSkils.name : ""}
            enterDelay={1500}
            placement="top"
          >
            <Autocomplete
              options={skils}
              disabled={disabled}
              disableClearable
              getOptionLabel={option =>
                option
                  ? `${option.code} | ${option.typeName} | ${option.name}`
                  : option
              }
              value={
                skils.find(item => item.id === moduleInformation.data.skill) ||
                ""
              }
              onChange={(event, item) => change("skill", item.id)}
              renderInput={params => (
                <TextField
                  {...params}
                  label="Компетенция"
                  InputLabelProps={{
                    shrink: true
                  }}
                  fullWidth
                  required
                />
              )}
            />
          </Tooltip>
        </Grid>
        <Grid item md={5} xs={12} className={classes.column}>
          <Tooltip
            title={tooltipSpecialities ? tooltipSpecialities.name : ""}
            enterDelay={1500}
            placement="top"
          >
            <Autocomplete
              options={specialities}
              disableClearable
              disabled={disabled}
              getOptionLabel={option =>
                option ? `${option.code} | ${option.name}` : option
              }
              value={
                specialities.find(
                  item => item.id === moduleInformation.data.speciality
                ) || ""
              }
              getOptionDisabled={option => option.deleted}
              onChange={(event, item) => change("speciality", item.id)}
              renderInput={params => (
                <TextField
                  {...params}
                  label="Профессия/Специальность"
                  InputLabelProps={{
                    shrink: true
                  }}
                  fullWidth
                  required
                />
              )}
            />
          </Tooltip>

          <Grid item xs={12} className={classes.columnRight}>
            <TextField
              label="Год"
              disabled={disabled}
              value={moduleInformation.data.year || ""}
              onChange={e => change("year", e.target.value)}
              InputLabelProps={{
                shrink: true
              }}
            />
            <TextField
              label="Объём"
              value={moduleInformation.info.duration || ""}
              disabled
              InputLabelProps={{
                shrink: true
              }}
            />
            <Autocomplete
              options={educationForm}
              disableClearable
              disabled={disabled}
              getOptionLabel={option => (option ? option.name : option)}
              value={
                (educationForm &&
                  educationForm.find(
                    item => item.id === moduleInformation.data.educationForm
                  )) ||
                ""
              }
              onChange={(event, item) => change("educationForm", item.id)}
              renderInput={params => (
                <TextField
                  {...params}
                  label="Форма обучения"
                  InputLabelProps={{
                    shrink: true
                  }}
                  fullWidth
                />
              )}
            />
            <Autocomplete
              options={trialForm}
              disableClearable
              disabled={disabled}
              getOptionLabel={option => (option ? option.name : option)}
              value={
                (trialForm &&
                  trialForm.find(
                    item => item.id === moduleInformation.data.trialForm
                  )) ||
                ""
              }
              onChange={(event, item) => change("trialForm", item.id)}
              renderInput={params => (
                <TextField
                  {...params}
                  label="Форма аттест."
                  InputLabelProps={{
                    shrink: true
                  }}
                  fullWidth
                />
              )}
            />
          </Grid>
        </Grid>
      </div>
      <div>
        <TextField
          label="Описание"
          disabled={disabled}
          value={moduleInformation.data.description || ""}
          onChange={e => change("description", e.target.value)}
          InputLabelProps={{
            shrink: true
          }}
          multiline
          rows="5"
        />
      </div>

      <div className={classes.status}>
        <InfoField
          name="Статус модуля"
          value={moduleInformation.info.statusName}
        />
        {moduleInformation.info.creationDate && (
          <InfoField
            name="Дата создания"
            value={moment(moduleInformation.info.creationDate).format(
              "DD.MM.YYYY"
            )}
          />
        )}
      </div>
      <div className={classes.files}>
        <div>
          <InfoField name="Изображение карточки" />
          <div className={classes.dropzoneWraper}>
            <div className={classes.dropZoneButtonArea}>
              {/*               <Tooltip title="Добавить/Изменить" placement="top">
                <IconButton
                  classes={{ root: classes.iconButton }}
                  onClick={image => {
                    addModuleCardLogo(image);
                  }}
                >
                  <IconEdit />
                </IconButton>
              </Tooltip> */}

              <Tooltip title="Удалить" placement="top">
                <IconButton
                  classes={{ root: classes.iconButton }}
                  onClick={() => deleteModuleCardLogo()}
                >
                  <IconRemove />
                </IconButton>
              </Tooltip>
            </div>
            <UploadDropzone
              type="card"
              accept={[".img", ".png"]}
              onDrop={image => {
                addModuleCardLogo(image);
              }}
            />
          </div>
        </div>
        <div>
          <InfoField name="Файл рабочей программы модуля" />
          <div>
            {program ? (
              <AttachmentCard
                id={program.fileId}
                mimeType={program.mimeType}
                fileName={program.fileName}
                fileSize={program.size}
                fileLink={program.fileId}
                download
                removeDocument={deleteModuleProgram}
              />
            ) : (
              disabled ? <div>не загружен</div> :
              <UploadDropzone
                onDrop={program => {
                  addModuleProgram(program);
                }}
                accept={[".pdf"]}
                maxSize={2000000}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default withStyles(useStyles)(BasicInfo);
